import { Point, Layer, GlobalContext } from "../../../context/context";
import { getIsochrone } from '../../../services/openRouteService';
import L from 'leaflet';

interface IsochroneHandlerProps {
    point: Point;
    mode: string;
    time: number;
    color: string;
    global: GlobalContext;
    mapRef: React.MutableRefObject<L.Map | null>;
    setIsochroneLoading: (loading: boolean) => void;
    setIsochroneError: (error: string | null) => void;
    setIsIsochroneModalOpen: (open: boolean) => void;
    setIsochronePoint: (point: Point | null) => void;
}

export async function handleCreateIsochrone({
    point,
    mode,
    time,
    color,
    global,
    mapRef,
    setIsochroneLoading,
    setIsochroneError,
    setIsIsochroneModalOpen,
    setIsochronePoint
}: IsochroneHandlerProps) {
    setIsochroneLoading(true);
    setIsochroneError(null);
    
    try {
        const isochrone = await getIsochrone(point, mode as any, time);
        
        // Update the isochrone with the user's chosen color
        isochrone.colour = color;
        isochrone.borderColour = color;

        // Add as new layer
        const newLayerId = global.mapLayers.length;
        const newLayer = {
            layerId: newLayerId,
            layerName: `Isochrone: ${isochrone.name}`,
            hidden: false,
            shapes: [isochrone],
        };
        global.setLayers((prev: Layer[]) => [...prev, newLayer]);
        global.setActiveLayerId(newLayerId);

        // Zoom to the isochrone
        if (mapRef.current && isochrone.coordinates[0].length > 0) {
            const bounds = L.latLngBounds(isochrone.coordinates[0].map(([lat, lng]: [number, number]) => [lat, lng]));
            mapRef.current.fitBounds(bounds.pad(0.2));
        }
    } catch (err) {
        setIsochroneError(err instanceof Error ? err.message : 'Failed to create isochrone');
    } finally {
        setIsochroneLoading(false);
        setIsIsochroneModalOpen(false);
        setIsochronePoint(null);
    }
} 